/**-------------------------------  Copyright ---------------------------------
This software has been developed by Orange Labs TGI/OLS/SOFT
Copyright (c) Orange Labs 2018

COPYRIGHT    : This file is the property of Orange Labs.
Copyright Orange Labs 2018, All Rights Reserved

This software is the confidential and proprietary information of Orange Labs.

You shall not disclose such Confidential Information and shall use it only
in accordance with the terms of the license agreement you entered into with
Orange Labs.

AUTHORS      : Orange Labs  TGI/OLS/SOFT
EMAIL        : soft.cybersec@orange.com
-----------------------------------------------------------------------------*/


import {Component, Prop, Vue, Watch} from 'vue-property-decorator'
import {SUCCESS_MESSAGE_TYPE} from '@/utils/constants'

const MILLISECONDS_BEFORE_CLEARING: number = 7000

@Component
export default class MessageBox extends Vue {

    @Prop({default: ''})
    public message: string

    @Prop({default: false})
    public autoClear: boolean

    private currentMessage: string = ''

    @Prop({default: SUCCESS_MESSAGE_TYPE })
    private type: string

    // without a watcher, currentMessage is not refreshed when message changes
    @Watch('message', { immediate: true })
    public onPropertyChanged(value: string, oldValue: string) {
        this.currentMessage = value
        if (this.autoClear && value !== '') {
            window.setTimeout(this.clearMessage, MILLISECONDS_BEFORE_CLEARING)
        }
    }

    private clearMessage() {
        this.currentMessage = ''
        // inform parent
        this.$emit('cleared')
    }

}
